import { PRICE_BUZZER, PRICE_BUZZER_STREAM, } from "../../../interface/iPriceBuzzer";
import { drivingMarketStreamingUpdate, } from "@domains/features/Markets/Equity/utils/streamingUpdate";
let initState = {
    data: [],
};
const priceBuzzer = (state = initState, action) => {
    switch (action.type) {
        case PRICE_BUZZER:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case PRICE_BUZZER_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketStreamingUpdate(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default priceBuzzer;
